import { apiClient } from '../client';
import { MenuPermission, MenuPermissionChange } from '@/types';

export const menuPermissionsApi = {
  getAll: () => 
    apiClient.get<MenuPermission[]>('/roles/menu-permissions/'),
  
  getForRole: (role: string) => 
    apiClient.get<MenuPermission[]>(`/roles/menu-permissions/for-role/${role}/`),
  
  bulkUpdate: (permissions: Array<{role: string; menu_id: string; is_allowed: boolean}>) =>
    apiClient.post('/roles/menu-permissions/bulk-update/', { permissions }),
  
  getAuditTrail: () =>
    apiClient.get<MenuPermissionChange[]>('/roles/menu-permissions/audit-trail/'),
};

